module.exports = __webpack_public_path__ + "img/BSC.742aaaae.png";